export default {"src":"/_next/static/media/loading.2ecec529.gif","height":120,"width":120,"blurWidth":0,"blurHeight":0};